// extracted by mini-css-extract-plugin
module.exports = {"menu":"AcDropdown_menu__1UMeT","linkDropdown":"AcDropdown_linkDropdown__1CGFr"};